/**
 * External redirect handler — aurora theme.
 * Mirrors the legacy AngularJS brew.external.Controller.
 * Redirects to an external URL passed via query parameter.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import AuroraBackground from '@/components/layout/AuroraBackground';
import LoadingSpinner from '@/components/common/LoadingSpinner';

export default function ExternalRedirectPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const url = searchParams.get('url');
    if (url) {
      window.location.href = url;
    }
  }, [searchParams]);

  return (
    <>
      <AuroraBackground />
      <div className="min-h-[var(--app-content-height)] flex items-center justify-center px-4">
        <LoadingSpinner message="Redirecting..." />
      </div>
    </>
  );
}
